export const BLOCK_POST_CLASSNAME = 'block-post';

export const WIDGET_COMMUNITY_POST_LIST_TYPE = 'community-post-list';

export const POST_LIST_FILTER_ID = 'post-list-filter';

export const PIN_POST_MAX_COUNT = 50;
